import { render, staticRenderFns } from "./part-1-global-kra-performance-details.vue?vue&type=template&id=4d8ff11b&scoped=true&"
import script from "./part-1-global-kra-performance-details.vue?vue&type=script&lang=js&"
export * from "./part-1-global-kra-performance-details.vue?vue&type=script&lang=js&"
import style0 from "./part-1-global-kra-performance-details.vue?vue&type=style&index=0&id=4d8ff11b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8ff11b",
  null
  
)

export default component.exports